// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__Q0CQz","icon":"style_icon__1D96i","title":"style_title__Op7Eg"};